import { Grid, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { DiscrepancyIndicator, Elements, SearchInput } from '@tfo/common'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { IndividualInformation } from '../../../../../models/IGroupSummary'
import { State } from "../../../../../models/enums/State"

const { Heading4 } = Elements

export type GroupedOrderReportListProps = {
    reports: IndividualInformation[]
    onSelectedReport: (report: IndividualInformation) => void
    isBackoffice?: boolean
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',

        marginBottom: '4em',
        width: '100%'

    },
    headerSpacing: {
        marginBottom: '0.5em'
    },
    searchAndFilter: {
        display: 'grid',
        gridTemplateColumns: '6fr 2fr 2fr 2fr 1fr',
        marginBottom: '30px',
        marginTop: '8px',
        "@media (max-width: 768px)": {
            display: 'grid',
            gridTemplateColumns: '6fr 4fr 4fr',
        },
    },
    ordersTableCell: {
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#FFFFFF',
        }
    },
    reportTableContainer: {
        marginTop: '3rem',
        display: 'flex',
        flexDirection: 'column',
        width: '60%'
    },
    h4: {
        letterSpacing: '0.3px',
        marginLeft: '20px',
        fontWeight: 'lighter',
    }
})

const GroupedOrderReportList = ({ reports, isBackoffice }: GroupedOrderReportListProps) => {
    const history = useHistory()
    const intl = useIntl()
    const style = useStyles()
    const intialPage: number = 0
    const rowsPerPage = 25

    const [currentPageIndex, setCurrentPageIndex] = React.useState<number>(intialPage)
    const [searchString, setSearchString] = React.useState<string>("")
    const [rows, setRows] = React.useState<IndividualInformation[]>([])
    const [filteredRows, setFilteredRows] = React.useState<IndividualInformation[]>([])
    const [totalRowCount, setTotalRowCount] = React.useState<number>(0)

    React.useEffect(() => {
        const rowsToDisplay = !isBackoffice ?
            reports.filter((item) => item.orderState === State.Delivered) : reports

        setRows(() => rowsToDisplay)
        setRowsForPage(rowsToDisplay, currentPageIndex, searchString)
        setTotalRowCount(rowsToDisplay.length)
    }, [])


    const filterRowsByPagination = (rows: IndividualInformation[], pageIndex: number): IndividualInformation[] => {
        return rows.slice(pageIndex * rowsPerPage, pageIndex * rowsPerPage + rowsPerPage)
    }

    const filterBySearch = (rows: IndividualInformation[], query: string): IndividualInformation[] => {
        return query !== '' ? rows.filter(
            (item) =>
                item.fullName.toLowerCase().includes(query)
        ) : rows
    }
    const setRowsForPage = (rows: IndividualInformation[], pageIndex: number, query: string) => {
        const filteredBySearchString = filterBySearch(rows, query)
        const pagedRows = filterRowsByPagination(filteredBySearchString, pageIndex)
        setFilteredRows(pagedRows)
    }

    const onChangePage = (event: unknown, pageIndex: number): void => {
        setCurrentPageIndex(pageIndex)
        setRowsForPage(rows, pageIndex, searchString)
    }

    const onClearSearch = (): void => {
        setSearchString(() => '')
        setCurrentPageIndex(0)
        setRowsForPage(rows, 0, '')
        setTotalRowCount(rows.length)
    }

    const onInputSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const query = e.target.value.toLowerCase()
        
        setRowsForPage(rows, 0, query)
        setTotalRowCount(filterBySearch(rows, query).length)
        setCurrentPageIndex(0)
        setSearchString(() => query)
    }

    const handleOnRowClick = (row: IndividualInformation): void => {
        history.push(`/read-report/${row.orderId}`)
    }

    return (
        <>
            <Grid
                container
                justifyContent="center"
                direction="column"
            >
                <Grid className={[style.container, 'container-fluid'].join(' ')}>
                    <Grid container className={`${style.reportTableContainer} `}>
                        <Heading4 className={style.headerSpacing}>
                            {intl.formatMessage({ id: 'archived.report.label.individuals' })}
                        </Heading4>
                        <div className={style.searchAndFilter}>

                            <SearchInput
                                value={searchString}
                                onInputChange={onInputSearch}
                                onClear={onClearSearch}
                                placeholder={intl.formatMessage({ id: 'reportsitem.ongoing.dialog.individualName' })}
                            />
                            <h4 className={style.h4}>{intl.formatMessage({ id: 'found.items' }) + ' '}<b>{totalRowCount}</b></h4>
                        </div>
                    </Grid>

                    <Grid container direction="column"  >
                        <Grid container>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        {filteredRows.map((row) => (
                                            <TableRow className={style.ordersTableCell} key={row.orderId} onClick={() => handleOnRowClick(row)}>
                                                <TableCell>{row.fullName}</TableCell>
                                                <TableCell>{row.nationalId}</TableCell>
                                                <TableCell>
                                                {!!row.reportSummary && (<DiscrepancyIndicator  title={intl.formatMessage({ id: 'common.reportWithDiscrepancy' })} body=''/>)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    count={totalRowCount}
                                    rowsPerPage={rowsPerPage}
                                    page={currentPageIndex}
                                    rowsPerPageOptions={[]}
                                    onPageChange={onChangePage}
                                />
                            </TableContainer>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}
export default GroupedOrderReportList




